import PropTypes from 'prop-types';
import WidthProp from '../width';

const propTypes = {
  width: WidthProp,
  space: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['horizontal', 'vertical'])]),
  spaceWithin: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['horizontal', 'vertical'])]),
  borderWidth: PropTypes.number
};

const defaultProps = {
  width: 'natural',
  space: false,
  spaceWithin: false,
  borderWidth: 0
};

const propDescriptions = {
  // eslint-disable-next-line max-len
  width: `The width of the component. (Can either pass in the width for all views eg. width={12}, or an object containing widths at different breakpoints eg. width={{ xs: 12, md: 6, xl: 4 }})

  Width Options:
    - natural: unsets any width prop and allows the component to be it's natural width
    - 1-12: width as a percentage out of 12
    - 0: hides the component ~ can be used to hide a component on mobile but show on desktop for example
    - pixel value: can pass in any string and it will set this as the components width (can use em/rem as well or even custom percentages)
    - even: only used in childrenWidth not width: evenly spaces all children across one row #layout
  `,
  space: 'Where should you add margin around the component - true adds horizontal & veritical margins - false prevents margins #layout',
  spaceWithin:
    'Where should you add padding around the component - true adds horizontal & veritical padding - false prevents padding #layout',
  borderWidth: 'The width (in pixels) of the border surrounding the component #layout'
};

const layoutProps = {
  propTypes,
  defaultProps,
  propDescriptions
};

export default layoutProps;
